import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import CodeIcon from '@atlaskit/icon/core/angle-brackets';
import ComponentIcon from '@atlaskit/icon/core/component';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import {
	mapSearchModeToAnalyticAtribute,
	SEARCH_MODE_BASIC,
	SEARCH_MODE_ADVANCED,
} from '@atlassian/jira-jql-builder/src/common/constants.tsx';
import type { SearchModeSwitcherProps } from '@atlassian/jira-jql-builder/src/common/types.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { messages } from './messages.tsx';

export const SearchModeToggleMenuItem = ({
	isBasicModeDisabled,
	onUpdateSearchMode,
	searchMode,
}: SearchModeSwitcherProps) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleUpdateSearchMode = () => {
		const nextSearchMode =
			searchMode === SEARCH_MODE_BASIC ? SEARCH_MODE_ADVANCED : SEARCH_MODE_BASIC;
		onUpdateSearchMode(nextSearchMode);

		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
		});

		fireUIAnalytics(analyticsEvent, 'jqlBuilderAiSearchModeToggle', {
			searchMode: mapSearchModeToAnalyticAtribute[nextSearchMode],
		});
	};

	if (searchMode === SEARCH_MODE_BASIC) {
		return (
			<DropdownItem
				onClick={handleUpdateSearchMode}
				elemBefore={<CodeIcon  spacing="spacious" label="" />}
			>
				{formatMessage(messages.advancedModeOverflowMenu)}
			</DropdownItem>
		);
	}

	const switchToBasicItem = (
		<DropdownItem
			isDisabled={isBasicModeDisabled}
			onClick={handleUpdateSearchMode}
			elemBefore={<ComponentIcon  spacing="spacious" label="" />}
		>
			{formatMessage(messages.basicModeOverflowMenu)}
		</DropdownItem>
	);

	return isBasicModeDisabled ? (
		<Tooltip content={formatMessage(messages.basicModeDisabledTooltip)} tag="span">
			{switchToBasicItem}
		</Tooltip>
	) : (
		switchToBasicItem
	);
};
